__turbopack_context__.v({
  "actions": "CenteredHero-module__KkMj4W__actions",
  "annotation": "CenteredHero-module__KkMj4W__annotation",
  "annotationArrow": "CenteredHero-module__KkMj4W__annotationArrow",
  "annotationLines": "CenteredHero-module__KkMj4W__annotationLines",
  "badge": "CenteredHero-module__KkMj4W__badge",
  "full": "CenteredHero-module__KkMj4W__full",
  "fullBelow": "CenteredHero-module__KkMj4W__fullBelow",
  "inner": "CenteredHero-module__KkMj4W__inner",
  "label": "CenteredHero-module__KkMj4W__label",
  "logoCaption": "CenteredHero-module__KkMj4W__logoCaption",
  "logoLink": "CenteredHero-module__KkMj4W__logoLink",
  "logoMarquee": "CenteredHero-module__KkMj4W__logoMarquee",
  "logoWindow": "CenteredHero-module__KkMj4W__logoWindow",
  "logos": "CenteredHero-module__KkMj4W__logos",
  "logosLabel": "CenteredHero-module__KkMj4W__logosLabel",
  "logosList": "CenteredHero-module__KkMj4W__logosList",
  "loop": "CenteredHero-module__KkMj4W__loop",
  "loopChar": "CenteredHero-module__KkMj4W__loopChar",
  "loopPrefix": "CenteredHero-module__KkMj4W__loopPrefix",
  "loopWord": "CenteredHero-module__KkMj4W__loopWord",
  "loopwordIn": "CenteredHero-module__KkMj4W__loopwordIn",
  "media": "CenteredHero-module__KkMj4W__media",
  "outline": "CenteredHero-module__KkMj4W__outline",
  "promise": "CenteredHero-module__KkMj4W__promise",
  "promiseNarrow": "CenteredHero-module__KkMj4W__promiseNarrow",
  "stars": "CenteredHero-module__KkMj4W__stars",
  "subtitle": "CenteredHero-module__KkMj4W__subtitle",
  "text": "CenteredHero-module__KkMj4W__text",
});
